import { useAuth } from "provider/AuthContext";
import { useOperatorProfileContext } from "provider/OperatorProfileProvider";
import React from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

const OperatorRatingSidebar = ({ type, ratings, operatorData }) => {
  const { packSlug, safarioperator, organized_slug, safariSlug } = useParams();
  const { isLoggedIn } = useAuth();
  const { operatorProfileDispatch } = useOperatorProfileContext();



  const operatorSlug = type === 'sharedSafari' ? organized_slug : safarioperator;
  const loginRedirectLink = type === 'sharedSafari'
    ? `/log-in?authclient=google&referrer=${encodeURIComponent(`/sharedsafari/${organized_slug}/${safariSlug}`)}`
    : `/log-in?authclient=google&referrer=${encodeURIComponent(`/package/${operatorSlug}/${packSlug}`)}`;
  const businessName = operatorData?.operator?.business_name || "this operator";
  const googleRating = operatorData?.partner?.google_rating || 0;
  const googleReviewCount = operatorData?.partner?.google_review_count || 0;

  const handleTabSwitch = () => {
    operatorProfileDispatch({
      type: "SET_PROFILE_ACTIVE_TAB",
      payload: 'reviews',
    });
  };

  return (
    <>
      {ratings?.length > 0 ? (
        <div className="request_quote mb-4 ">
          <Button
            className="intested_btn interestBtn d-flex justify-content-between"
            style={{ backgroundColor: "var(--background-primary)", cursor: "default" }}

          >
            Operator Rating <span>{googleRating}/5 ({googleReviewCount})</span>
          </Button>

          <div className="interst_wrapper pt-1 px-3 bg-white">
            <div id="review-list">
              {ratings.slice(0, 3).map((review, index) => (
                <div key={index} className="commentsOther2 position-relative">
                  <div className="postcomment pt-3 ms-3 mt-1">
                    <div className="text_com colors_p">
                      <div className="providerNamerating">
                        <div className="googlerating names">
                          {review.user && (
                            <a href={`/profile/default/index?user_handle=${review.user.user_handle}`}>
                              <h6 className="mb-0 fs-6 pb-0">{review.user.name}</h6>
                            </a>
                          )}
                        </div>
                        <div className="ratings colors">
                          <p className="mb-0">
                            {[...Array(5)].map((_, i) => (
                              <i key={i} className={i < review.rating ? "fa-solid fa-star" : "far fa-star"}></i>
                            ))}
                          </p>
                        </div>
                      </div>
                      <p className="suggest">{review.review} &nbsp;</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-12">
              <div className="safari text-center mt-4">
                <div className="viewAllreview">
                  <Link
                    to={`/operator/${operatorSlug}/profile/reviews`}
                    onClick={handleTabSwitch}

                  >View All</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="request_quote mb-4">
          <Button
            className="intested_btn interestBtn d-flex justify-content-between"
            style={{ backgroundColor: "var(--background-primary)", cursor: "default" }}

          >
            Operator Rating
          </Button>

          <div className="interst_wrapper px-3 bg-white text-center">
            <p className="mb-0">Nobody has shared any review about</p>
            <p className="mb-0 mt-2">{businessName}</p>

            {isLoggedIn ? (
              <p>
                <Link
                  className="writeAReviewBtn text-capitlize sent_btn rounded-2 mt-2"
                  style={{ color: "white", textDecoration: "none" }}
                  to={`/operator/${operatorSlug}/profile/reviews`}
                  onClick={handleTabSwitch}
                >
                  Share Your Review
                </Link>
              </p>
            ) : (
              <p>
                <Link
                  className="sent_btn rounded-2 mt-2"
                  style={{ color: "white", textDecoration: "none" }}
                  to={loginRedirectLink}
                >
                  Share Your Review
                </Link>
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default OperatorRatingSidebar;
